import { render, staticRenderFns } from "./TeacherLinking.vue?vue&type=template&id=7f33d7d4&scoped=true&"
import script from "./TeacherLinking.vue?vue&type=script&lang=js&"
export * from "./TeacherLinking.vue?vue&type=script&lang=js&"
import style0 from "./TeacherLinking.vue?vue&type=style&index=0&id=7f33d7d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f33d7d4",
  null
  
)

export default component.exports